import React, {Component} from "react";
import { Card, Table, Button, FormGroup, FormControl, FormLabel, Row, Col } from "react-bootstrap";
import key from "../../../config/key.json";
import { toast } from "react-toastify";
import { getFromStorage } from "../../../utils/storage";
import errorConfig from "../../../config/errorConfig.json";
import { withRouter } from "react-router";
import api from "../../../config/api.json";
import { CircularProgress } from "@material-ui/core";
import axios from 'axios';

const color = "#229a88";

class ProviderPatients extends Component {
    state = {
        isLoading: true,
        isSearching: false,
        patients: [],
        phone: ""
    }
    //Error Notification
    notifyError = error => {
        toast.error("" + error.toString());
    };

    //Success Notification
    notifySuccess = success => {
        toast.success("" + success.toString());
    };

    //fetch appointments
    fetchPatientDetail = (e) => {
        e.preventDefault();
        toast.dismiss();
        this.setState({isSearching: true }, () => { 
            const body = {
                task: 'getPatientDetails',
                phone: this.state.phone
            }
            const headers = { headers: { "Content-Type" : "application/json" } }
            axios.post(api.ProviderApi, body, headers)
            .then(res => {
                if(!res.data.errorMessage){
                    this.setState({patients: res.data})
                } else {
                    this.notifyError("Not Found")
                }
                this.setState({isLoading: false, isSearching: false, phone: ""})
            }
            )
            .catch(err => {
                this.notifyError(err.toString())
                this.setState({isLoading: false, isSearching: false})
            })
        })
    }

    //Remove Doctor
    removePatient = () => {
        toast.dismiss();
        const body = {
            task: 'removePatient',
            phone: this.state.patients[0].phone
        }
        const headers = { headers: { "Content-Type" : "application/json" } }
        axios.post(api.ProviderApi, body, headers)
        .then(res => {
            if(!res.data.errorMessage){
                this.setState({patients: []})
            } else {
                this.notifyError("Not Found")
            }
            this.setState({isLoading: false, isSearching: false})
        }
        )
        .catch(err => {
            this.notifyError(err.toString())
            this.setState({isLoading: false, isSearching: false})
        })
    }

    //First function run when page load
    componentDidMount() {
        toast.dismiss();
        
        if (!getFromStorage(key.loginInfoKey)) {
            this.notifyError(errorConfig.notLoggedInError);
            this.props.history.push("/");
        } else if (getFromStorage(key.loginInfoKey).task === "authAdmin" || getFromStorage(key.loginInfoKey).task === "authDiagAdminPanel") {
            this.props.history.push("/Graph");
        } else if (getFromStorage(key.loginInfoKey).task === "patient") {
            this.props.history.push("/home");
        } else if (getFromStorage(key.loginInfoKey).task === "doctor") {
            this.props.history.push("/home");
        } else {
            this.setState({isLoading: false});
        }
    }

    render() {
        if(this.state.isLoading) {
            return (
                <div style={{marginLeft: this.props.isOpened ? (window.innerWidth > 560 ? "180px" : "20px") : "20px", marginTop: "70px", textAlign: "center"}}>
                    <CircularProgress />
                </div>
            )
        }
        return (
            <div style={{marginLeft: this.props.isOpened ? (window.innerWidth > 560 ? "180px" : "20px") : "20px", marginTop: "70px", marginRight: "20px"}}>
                <Card style={{padding: "20px", fontSize: "14px"}} className="shadow-4">
                    <h3 style={{color, textAlign: "center", fontWeight: "bold"}}>Patients Management</h3>
                    <form onSubmit={this.fetchPatientDetail}>
                        <Row>
                            <Col sm="3">
                                <FormGroup controlId="search">
                                    <FormLabel>Search Patient:</FormLabel>
                                    <FormControl 
                                        placeholder="Phone Number (eg. 01712345678)"
                                        pattern="[0-9]*"
                                        value={this.state.phone}
                                        size="sm"
                                        onChange={(e) => {
                                            if(e.target.validity.valid)
                                                this.setState({phone: e.target.value})
                                        }}
                                    />  
                                </FormGroup>
                            </Col>
                            <Col>
                                <Button size="sm" variant="success" type="submit" style={{marginTop: 27}}>
                                    Search
                                </Button>
                            </Col>
                        </Row>
                    </form>
                    {!this.state.isSearching ?
                        <Table striped bordered hover size="sm">
                            <thead>
                                <tr style={{color, fontWeight: "bold"}}>
                                    <th>Id</th>
                                    <th>Name</th>
                                    <th>Phone</th>
                                    <th>Gender</th>
                                    <th>Age</th>
                                    <th></th>
                                    <th></th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    this.state.patients.map(item =>
                                        <tr key={item.id}>
                                            <td>{item.id}</td>
                                            <td>{item.name}</td>
                                            <td>{item.phone}</td>
                                            <td>{item.gender === "M" ? "Male" : "Female"}</td>
                                            <td>{item.age}</td>
                                            <td align="center">
                                                <Button
                                                    style={{width: "130px"}}
                                                    size="sm" 
                                                    variant="info"
                                                    onClick={() => {
                                                        this.props.history.push(`/patient/appointment_list/${item.id}`)
                                                    }} 
                                                >
                                                    <span style={{marginLeft: "5px"}}>Appointment List</span>
                                                </Button>
                                                <br/>
                                                <Button
                                                    style={{marginTop: "5px", width: "130px"}}
                                                    size="sm" 
                                                    variant="secondary" 
                                                    onClick={() => {
                                                        this.props.history.push(`/payment_setup/${item.id}`)
                                                    }}
                                                >
                                                    <span style={{marginLeft: "5px"}}>Payment Setup</span>
                                                </Button>
                                            </td>
                                            <td align="center">
                                                <Button
                                                    style={{width: "150px"}}
                                                    size="sm" 
                                                    variant="primary"
                                                    onClick={() => {
                                                        this.props.history.push(`/call_list/${item.id}`)
                                                    }} 
                                                >
                                                    <span style={{marginLeft: "5px"}}>Call List</span>
                                                </Button>
                                                <br/>
                                               
                                                <Button
                                                    style={{width: "150px", marginTop: "5px"}}
                                                    size="sm" 
                                                    variant="success" 
                                                    onClick={() => {
                                                        this.props.history.push(`/patient/change_pass/${item.phone}`)
                                                    }}
                                                >
                                                    <span style={{marginLeft: "5px"}}>Change Password</span>
                                                </Button>
                                            </td>
                                            <td align="center">
                                                <Button
                                                    style={{width: "150px"}}
                                                    size="sm" 
                                                    variant="info"
                                                    onClick={() => {
                                                        this.props.history.push(`/calculate_bills/${item.id}`)
                                                    }} 
                                                >
                                                    <span style={{marginLeft: "5px"}}>Calculate Bills</span>
                                                </Button>
                                                <br/>
                                                <Button
                                                    style={{width: "150px", marginTop: "5px"}}
                                                    size="sm" 
                                                    variant="danger"
                                                    onClick={this.removePatient} 
                                                >
                                                    <span style={{marginLeft: "5px"}}>Remove</span>
                                                </Button>
                                            </td>
                                            
                                        </tr>
                                    )
                                }
                            </tbody>
                        </Table>
                        :
                        <div style={{textAlign: "center"}}>
                            <CircularProgress />
                        </div>
                    }
                </Card>
                <br/>
            </div>
        )
    }
}

export default withRouter(ProviderPatients);